export default "__VITE_ASSET__CEqfcgYs__"